// iOS leaves the layout viewport full height under the keyboard, so the pinned
// shell runs on beneath it and a field low on the page stays covered. While
// the keyboard is open this sizes the document to the visible area (see
// globals.css), sets data-keyboard on <html> so the tab bar and FAB hide, and
// undoes the pan iOS adds on focus, which lifts the header off the screen.
export const fitToKeyboard = () => {
	const viewport = window.visualViewport
	if (!viewport) return
	const root = document.documentElement

	const panned = () => window.scrollY !== 0 || viewport.offsetTop !== 0

	// Unpans before revealing, or the field looks visible inside the pan and
	// then drops behind the keyboard when the pan is undone.
	const settle = () => {
		if (panned()) window.scrollTo(0, 0)
		const field = document.activeElement
		if (
			field instanceof HTMLInputElement ||
			field instanceof HTMLTextAreaElement
		) {
			field.scrollIntoView({ block: 'nearest' })
		}
	}

	const fit = () => {
		root.style.setProperty('--visible-h', `${viewport.height}px`)
		// innerHeight stays at the layout viewport, so the gap is the keyboard.
		root.toggleAttribute(
			'data-keyboard',
			window.innerHeight - viewport.height > 100,
		)
		settle()
	}

	viewport.addEventListener('resize', fit)
	// iOS can pan after the resize, too.
	viewport.addEventListener('scroll', () => {
		if (panned()) settle()
	})
	fit()
}
